import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  snapMode: false,
  objectSnap: false,
  orthoMode: false,
  // AutoCAD-like: grid mode varsayılan kapalı, F9 / F7 / toolbar ile aç-kapa.
  gridMode: false,
  // Grid adımı — duvar ile tesisat çizgisi arası mesafe (5 birim).
  // applyGridSnap ile relative olarak kullanılır (başlangıç noktasına göre).
  gridStep: 5,
  snapTargets: {
    mimariCizim: true,      // DXF'ten gelen mimari objeler
    kullaniciCizim: true,   // Kullanıcının draw menüsünden yaptığı çizimler
    tesisatCizim: true,     // Tesisat çizimleri (wiring, panel bağlantıları)
    dokumanlar: false,      // Dokümanlar (layout grupları, başlıklar)
  },
  enabledSnapTypes: {
    endpoint: true,
    midpoint: true,
    center: true,
    vertex: true,
    quadrant: true,
    intersection: true,
    perpendicular: true,
    tangent: true,
    nearest: true,
    node: true,
    extension: true,
  },
};

const modsSlice = createSlice({
  name: "mods",
  initialState,
  reducers: {
    toggleSnapMode: (state) => {
      state.snapMode = !state.snapMode;
    },
    setSnapMode: (state, action) => {
      state.snapMode = action.payload;
    },
    toggleObjectSnap: (state) => {
      state.objectSnap = !state.objectSnap;
    },
    setObjectSnap: (state, action) => {
      state.objectSnap = action.payload;
    },
    // Yeni ortho mod reducerları:
    toggleOrthoMode: (state) => {
      state.orthoMode = !state.orthoMode;
    },
    setOrthoMode: (state, action) => {
      state.orthoMode = action.payload;
    },
    // Grid mod reducerları:
    toggleGridMode: (state) => {
      state.gridMode = !state.gridMode;
    },
    setGridMode: (state, action) => {
      state.gridMode = action.payload;
    },
    setGridStep: (state, action) => {
      const v = Number(action.payload);
      if (v > 0 && isFinite(v)) state.gridStep = v;
    },
    setSnapTarget: (state, action) => {
      const { key, value } = action.payload;
      state.snapTargets[key] = value;
    },
    setAllSnapTargets: (state, action) => {
      const value = action.payload;
      Object.keys(state.snapTargets).forEach(k => { state.snapTargets[k] = value; });
    },
    toggleSnapType: (state, action) => {
      const key = action.payload;
      state.enabledSnapTypes[key] = !state.enabledSnapTypes[key];
    },
    setAllSnapTypes: (state, action) => {
      const value = action.payload;
      Object.keys(state.enabledSnapTypes).forEach(k => {
        state.enabledSnapTypes[k] = value;
      });
    },
  }
});

export const {
  toggleSnapMode,
  setSnapMode,
  toggleObjectSnap,
  setObjectSnap,
  toggleOrthoMode,
  setOrthoMode,
  toggleGridMode,
  setGridMode,
  setGridStep,
  setSnapTarget,
  setAllSnapTargets,
  toggleSnapType,
  setAllSnapTypes,
} = modsSlice.actions;

export default modsSlice.reducer;
